"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSectionTitle = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
require("./index.scss");
const className = 'page-section-title';
const PageSectionTitle = (props) => {
    const { text, modificators } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("h3", { className: classNames },
        react_1.default.createElement("span", { className: `${className}__text` }, text)));
};
exports.PageSectionTitle = PageSectionTitle;
//# sourceMappingURL=index.js.map